// extracted by mini-css-extract-plugin
module.exports = {"image":"image_3kzlR","contained":"image_1Y3HD","stretched":"image_E3si5"};